export const freeProductPlacholder = {
  name: "Free",
  description:
    "Blumira's Free Edition connects to and detects Microsoft 365 security events.",
  productId: null,
  priceId: null,
  listItems: [
    "1 cloud integration - Microsoft 365",
    "Unlimited users and data ingestion",
    "1 week data retention",
    "Detections and response",
    "Basic reporting",
    "Summary dashboard",
  ],
};

export const productKeys = ["Microsoft 365", "Cloud", "Advanced"];
